import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '日期';
var name = 'datePicker';
export default {
  icon: 'iconfont iconriqi1',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {}
    };
  },
  props: function props() {
    return [makeRequiredRule()];
  },
  basic: function basic() {}
};